import { APP_VERSION } from '../app/version';
export const environment = {
  sk:"dasdas526#",
  production: false,
  version: APP_VERSION,
  domain:"General Security APP",
  baseApiUrl:"https://api.cporteria.bedadev.cl/",
  baseWebsiteUrl:"https://api.cporteria.bedadev.cl",
  websocketUrl:"wss://socket-panic.vps.controlporteria.cl",
  recaptchaSiteKey: "6LfLgF4nAAAAAD6AGkpGY9m-0RmCCiE0ogoLJBei"
};
